import React, { useEffect } from 'react'
import { observePageState, updatePageState } from 'front-end-core/services/PageStateService'
import cx from 'classnames'
import CommentEditorContainer from 'redux/containers/components/comments/CommentEditorContainer'
import CommentHeaderContainer from 'redux/containers/pages/comments/CommentHeaderContainer'
import useBaseState from 'hooks/useBaseState'
import { map } from 'rxjs/operators'

const CommentPanel = ({
  commentPreview,
  commentNode,
  commentNode: { reference, target, category },
  commentPath,
  commentReference,
  previousReference,
  commentCategory,
  index,
  isLast
}) => {
  const { baseState: { show } } = useBaseState(
    observePageState(commentNode.id).pipe(map(show => ({ show }))), { show: 0 }
  )

  useEffect(() => {
    updatePageState({ [commentNode.id]: 0 })
  }, [commentPreview, commentNode.id])

  const togglePreview = () => {
    updatePageState({ [commentNode.id]: 1 - show })
  }

  const displayCommentHeader = (!previousReference || commentReference.id !== previousReference.id)

  return (
    <div className={cx({ 'bt b--cadet-blue pt4': index !== 0 && displayCommentHeader })}>
      {displayCommentHeader && (
        <CommentHeaderContainer
          {...{ previousReference, commentReference, commentPreview, show, commentPath, isLast, togglePreview }}
        />
      )}
      <CommentEditorContainer
        {...commentNode}
        commentReference={reference}
        commentTarget={target}
        commentCategory={category || commentCategory}
        commentLink={`${commentReference.link}?comment=${commentNode.id}`}
      />
    </div>
  )
}

export default CommentPanel
